import icons from './icons.json'

export const dialogLabels: BenefitStoreContext[string]['dialogLabels'] = {
	addToPlan: {
		description: 'Select a method to add staff to your existing plan',
		title: 'Add Staff To Plan',
		options: {
			batch: { title: 'Batch Add', description: 'Upload list of staff to add via an excel sheet' },
			manual: { title: 'Manual Add', description: 'Enter staff details to add' }
		}
	},
	removeFromPlan: {
		title: 'Remove staff',
		description: 'Select a method to remove staff',
		options: {
			batch: {
				title: 'Batch Removal',
				description: 'Upload the list of staff to remove via an Excel sheet.'
			},
			manual: {
				title: 'Manual Removal',
				description: 'Select the staff to remove'
			}
		}
	}
}

export const zencare_standard: BenefitStoreContext[string] = {
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				"Your HMO ID is the enrollment number you present at the hospital to access care. It's important to have your HMO ID with you, as it is required for treatment at any of the listed hospitals.",
				'Renewing your plan consistently helps you keep all the benefits without losing them.',
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling, video calling or chatting with a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			]
		},
		'Total Hospitals': {
			icon: icons.hospital,
			isOpen: false,
			key: 'hospital',
			value: [
				{
					text: 'Your staff gains access to over 1200 hospitals across Nigeria.'
				}
			]
		},
		'Your Business Will Enjoy': {
			icon: icons.business,
			isOpen: false,
			value: [
				'Treatment of everyday illnesses, like malaria and more.',
				'Coverage for general and specialist consultations, including 24-hour toll-free calls with healthcare professionals.',
				'Access to minor, intermediate, and major surgeries up to ₦200,000.',
				'Coverage for accident and emergency care services, including ambulance and ICU services.',
				'Extensive treatment options for chronic conditions, medication, and hospital admissions.',
				'Coverage for delivery and ante-natal care, including assisted deliveries and c-sections.',
				'A digital HMO ID for each person.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Access to general and specialist consultations.',
				'24 hours telemedicine services: chat with doctors and nurses.',
				'Coverage for hospital admissions and laboratory tests for chronic conditions.',
				'Fertility investigation and treatments of up to ₦15,000 annually.',
				'Coverage for family planning services, contraceptives and implants.',
				'Immunisation for children(0-5years) including BCG, OPV, DPT, IPV, Vitamin A, measles, yellow fever, meningitis.',
				'Additional immunisation coverage for 6 years and above, including HPV Vaccine and Hepatitis B.',
				'Ambulance services and resuscitative care for accident and emergency cases, including basic radiological and laboratory investigations needed to stabilize a patient before being moved to the ICU if need be.',
				'Access to Intensive Care Unit(ICU) including comatose patients, ventilator care and more, for up to 2 days.',
				'Coverage for diagnostic services including X-Rays, ultrasounds, CT scans and emergency MRIs.',
				'Coverage for Laboratory tests including hematology, chemistry, microbiology, serology.',
				'General ward admissions, accommodation and feeding for in-patient care.',
				'Ear, Nose & Throat(ENT) specialist care coverage.',
				'Access to routine eye tests and up to ₦15,000 coverage for lenses or frames annually.',
				'Primary and secondary dental care coverage for up to ₦20,000.',
				'Up to 5 sessions for Physiotherapy care, including drugs, annually.',
				'Coverage for minor, intermediate, and major surgeries up to ₦200,000.',
				'Protection for delivery and ante-natal care including assisted deliveries and c-sections.',
				'Neo-natal care including male circumcision and ear piercing, intensive care & life support, incubator care for 2 days up to ₦100,000.',
				'Renal care and Dialysis for 3 sessions annually.',
				'Cancer care including consultation, admission, hospice, chemotherapy, and radiotherapy for up to ₦300,000.',
				'Wellness checks including BMI, HIV, hypertension, diabetes, blood group, urinalysis and other general physical examinations.',
				'Access to HIV care and treatment services.',
				'Mental health outpatient consultations for up to 4 weeks.',
				'Psychiatry care for mental illnesses (2 sessions), up to ₦20,000.',
				'5% discount on fitness and nutritional club membership (for non-network gyms).',
				'After demise care and death cover for up to ₦50,000.',
				'Diagnosis and line of treatment confirmation from secondary/tertiary care centres.'
			],
			need_to_know: [
				"Your HMO ID is the enrollment number you present at the hospital to access care. It's important to have your HMO ID with you, as it is required for treatment at any of the listed hospitals.",
				'Renewing your plan consistently helps you keep all the benefits without losing them.',
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling, video calling or chatting with a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			],
			'How to get covered': [
				'Purchase the plan and add your staff.',
				'Ask the policyholders (your staff) to activate their plans, or do it yourself from your dashboard.',
				'After activation, the e-HMO ID will be automatically generated.',
				`${WAITING_PERIOD} hours after activation, your staff can present their HMO ID at any of the hospitals under the plan to receive healthcare.`
			]
		}
	},
	product_title: 'Boost team productivity with quality healthcare',
	card_label:
		'Affordable coverage with consultations, 24/7 access, and surgeries up to ₦200,000. Excellent value at mcg_price per staff.',
	dialogLabels
}
